import React from 'react'
import { skipLinks } from '../../lib/accessibility'
import { cn } from '../../lib/utils'

export const SkipLinks: React.FC = () => {
  return (
    <div className="sr-only focus-within:not-sr-only">
      {skipLinks.map((link) => (
        <a
          key={link.href}
          href={link.href}
          className={cn(
            'absolute top-0 left-0 z-50 p-4 bg-liec-primary text-white',
            'focus:relative focus:z-auto focus:block',
            'transition-all duration-200',
            'hover:bg-liec-primary-dark focus:bg-liec-primary-dark'
          )}
        >
          {link.text}
        </a>
      ))}
    </div>
  )
}